import * as React from 'react'

import { useWhitelabel } from 'main/framework'
import { palette, SmartImage, Tag, Title } from 'main/ui'

import RatingDisplay from 'main/components/school/Callout/common/RatingDisplay'
import { AssetName } from 'main/util/asset'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'
import { i18nKeyPrefix } from '../i18n'
import {
  AvatarContainer,
  avatarImageStyles,
  avatarSizeDesktop,
  Container,
} from './DirectorProfile.styles'

const PRE = `${i18nKeyPrefix}-DIRECTOR-PROFILE`

interface IProps {
  aggregateRatings?: {
    count: number
    overall: number | null
  }
  avatarUrl: string
  firstName: string | null
  lastName: string | null
}

export default function DirectorProfile(props: IProps) {
  const { aggregateRatings, avatarUrl, firstName, lastName } = props
  const whitelabel = useWhitelabel()

  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <Container>
      <AvatarContainer>
        <SmartImage
          height={avatarSizeDesktop}
          width={avatarSizeDesktop}
          css={avatarImageStyles}
          src={avatarUrl}
        />
      </AvatarContainer>
      <Title kind="section">
        {firstName} {lastName}
      </Title>
      <Tag color={palette.slate}>{t(`${PRE}-TAG`)}</Tag>
      {aggregateRatings &&
        aggregateRatings.overall &&
        whitelabel.showByDefaultExceptIfFalse(
          AssetName.WONDERSCHOOL_RATING_DISPLAY__LISTING__DIRECTOR_PROFILE,
        ) && (
          <RatingDisplay
            count={aggregateRatings.count}
            size={13}
            value={aggregateRatings.overall}
          />
        )}
    </Container>
  )
}
